import styled from "styled-components";

/* ===== Overlay / Card ===== */
export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;

  /* 최상위 레이어 */
  z-index: 2147483647;

  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);

  display: grid;
  place-items: start center;
  padding: 48px 16px 16px;
`;

export const ModalCard = styled.div`
  width: 100%;
  max-width: 520px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.22);
  padding: 18px;

  animation: popIn 0.12s ease;
  @keyframes popIn {
    from {
      transform: scale(0.98);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
`;

export const ModalTitle = styled.h4`
  margin: 4px 0 6px;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
`;

export const ModalDesc = styled.p`
  margin: 0 0 14px;
  font-size: 13px;
  color: #334155;
  line-height: 1.5;
`;

/* ===== Form ===== */
export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: grid;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 800;
  color: #334155;
`;

export const LabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 8px;
`;

export const Badge = styled.span<{ $muted?: boolean }>`
  font-size: 11px;
  font-weight: 800;
  padding: 2px 8px;
  border-radius: 999px;
  color: ${(p) => (p.$muted ? "#475569" : "#0f172a")};
  background: ${(p) =>
    p.$muted ? "rgba(148,163,184,0.18)" : "rgba(226,232,240,0.7)"};
  border: 1px solid rgba(148, 163, 184, 0.35);
`;

export const Counter = styled.span`
  font-size: 11px;
  color: #64748b;
  font-weight: 700;
`;

export const InputWrap = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 36px;
  border-radius: 10px;
  padding-left: 34px; /* 아이콘 영역 */
  padding-right: 64px; /* 오른쪽 액션 버튼 영역 */
  border: 1px solid #e5e7eb;
  background: #ffffff;
  transition: border-color 0.15s ease, box-shadow 0.15s ease,
    background 0.15s ease;

  &:focus-within {
    border-color: #93c5fd;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.25);
  }

  &[data-valid="false"] {
    border-color: #fecaca;
    box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.18);
  }
`;

export const LeftIcon = styled.svg`
  position: absolute;
  left: 10px;
  width: 16px;
  height: 16px;
  color: #94a3b8;
`;

export const RightActions = styled.div`
  position: absolute;
  right: 6px;
  display: inline-flex;
  gap: 6px;

  button {
    height: 26px;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    background: #f8fafc;
    font-size: 12px;
    font-weight: 800;
    color: #0f172a;
    cursor: pointer;
    transition: transform 0.08s ease, background 0.15s ease,
      border-color 0.15s ease;

    &:hover {
      transform: translateY(-1px);
      background: #eef2f7;
      border-color: #cbd5e1;
    }
    &:active {
      transform: translateY(0);
    }
  }
`;

/* ✅ 모든 입력을 string(text)으로 */
export const Input = styled.input.attrs({ type: "text" })`
  width: 100%;
  height: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: #0f172a;
  font-size: 13px;
  padding: 0 12px 0 0;
  &::placeholder {
    color: #9ca3af;
  }
`;

export const Hint = styled.p<{ $invalid?: boolean }>`
  margin: 0;
  font-size: 11.5px;
  color: ${(p) => (p.$invalid ? "#b91c1c" : "#64748b")};
`;

/* ===== Actions ===== */
export const ModalActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 6px;
`;

export const ModalBtn = styled.button<{ $danger?: boolean }>`
  min-width: 96px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
  background: ${(p) => (p.$danger ? "#22c55e" : "#ffffff")};
  color: ${(p) => (p.$danger ? "#fff" : "#0f172a")};
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.1s ease, box-shadow 0.15s ease, background 0.15s ease,
    border-color 0.15s ease, opacity 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
    background: ${(p) => (p.$danger ? "#16a34a" : "#f8fafc")};
    border-color: #cbd5e1;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;
